import React from "react";
import { createRoot } from "react-dom/client";
import { IntlProvider } from "react-intl";
import App from "./App";
import { FirebaseProvider } from "./providers/FirebaseProvider/FirebaseProvider";
import AuthenticationProvider from "./providers/AuthenticationProvider/AuthenticationProvider";
import NotificationProvider from "./providers/NotificationsProvider/NotificationProvider";
import StatusProvider from "./providers/StatusProvider/StatusProvider";
import ClubsProvider from "./providers/ClubsProvider/ClubsProvider";

const container = document.getElementById("root");
const root = createRoot(container);
const locale = navigator.language;

const messages = {
  "2set_tiebreak": "2 set + tiebreak",
  best_of_3: "Al meglio di 3 set",
  best_of_5: "Al meglio di 5 set",
  "1set": "1 set",
  "1setTC": "1 set Team Cup",
  single: "Singolo",
  double: "Doppio",
};

root.render(
  <React.StrictMode>
    <FirebaseProvider>
      <AuthenticationProvider>
        <ClubsProvider>
          <StatusProvider>
            <NotificationProvider>
              <IntlProvider locale={locale} messages={messages}>
                <App />
              </IntlProvider>
            </NotificationProvider>
          </StatusProvider>
        </ClubsProvider>
      </AuthenticationProvider>
    </FirebaseProvider>
  </React.StrictMode>,
);
